import type { NotifyPreferences } from "@/bryntum-lib/models/NotifyPrefrences";
import type { ISwivuProject } from "@/types/SwivuProject";
import type { ISwivuStore } from "@/types/SwivuStore";

export interface NotifyPreferenceRecord {
  id: string | number;
  userId?: number;
  notifyType: number;
  isEmailNotify: boolean;
  isWorkforceNotify: boolean;
  interupt: boolean;
  bannerNotify: number;
  order: number;
}

export function getNotifyPreferenceStore(
  project: ISwivuProject | null | undefined,
): ISwivuStore<NotifyPreferences> | null {
  return project?.notifyPreferenceStore ?? null;
}

export function getNotifyPreferenceRecords(
  project: ISwivuProject | null | undefined,
  userId?: number | null,
): NotifyPreferenceRecord[] {
  const store = getNotifyPreferenceStore(project);
  if (!store) return [];
  const fromRecords = store.records;
  const all: NotifyPreferenceRecord[] = fromRecords?.length
    ? (fromRecords as unknown as NotifyPreferenceRecord[])
    : ((store.query(() => true, true) ?? []) as unknown as NotifyPreferenceRecord[]);
  return userId == null ? all : all.filter((r) => r.userId === userId);
}
